export const GET_LANDING_PAGES_REQUEST = 'GET_LANDING_PAGES_REQUEST';
export const GET_LANDING_PAGES_SUCCESS = 'GET_LANDING_PAGES_SUCCESS';
export const GET_LANDING_PAGES_FAILED = 'GET_LANDING_PAGES_FAILED';

export const DELETE_LANDING_PAGE_REQUEST = 'DELETE_LANDING_PAGE_REQUEST';
export const DELETE_LANDING_PAGE_SUCCESS = 'DELETE_LANDING_PAGE_SUCCESS';
export const DELETE_LANDING_PAGE_FAILED = 'DELETE_LANDING_PAGE_FAILED';
